// extracted by css-extract-rspack-plugin
export default {"ViolationsListSummary":"ViolationsList-module__ViolationsListSummary__ky5Nx"};